import { createSlice } from "@reduxjs/toolkit";

// Initial state for the settings slice
const initialState = {
  fullscreenEnabled: false, // Default: Fullscreen mode off
  autoSpinCount: 10,
  autoPlayActive: false,
  remainingAutoSpins: 10, // Initialize with the same value as autoSpinCount
  simulationModeEnabled: false,
};

// Create the settings slice
const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    // Toggle fullscreen mode
    toggleFullscreen(state) {
      const element = document.documentElement;

      if (!state.fullscreenEnabled) {
        element.requestFullscreen().catch((err) => {
          console.error(`Error enabling fullscreen mode: ${err.message}`);
        });
      } else {
        document.exitFullscreen().catch((err) => {
          console.error(`Error exiting fullscreen mode: ${err.message}`);
        });
      }

      state.fullscreenEnabled = !state.fullscreenEnabled;
    },

    // Explicitly close fullscreen mode
    closeFullscreen(state) {
      if (document.fullscreenElement) {
        document.exitFullscreen().catch((err) => {
          console.error(`Error exiting fullscreen mode: ${err.message}`);
        });
      }
      state.fullscreenEnabled = false; // Always update the state
    },

    setAutoSpinCount(state, action) {
      state.autoSpinCount = action.payload;
      state.remainingAutoSpins = action.payload; // Reset remaining spins when autoSpinCount is set
    },

    startAutoPlay(state) {
      state.autoPlayActive = true;
      state.remainingAutoSpins = state.autoSpinCount; // Reset remaining spins to the initial autoSpinCount
    },

    stopAutoPlay(state) {
      state.autoPlayActive = false;
    },

    toggleSimulationMode(state) {
      state.simulationModeEnabled = !state.simulationModeEnabled;
    },

    setSimulationMode(state, action) {
      state.simulationModeEnabled = action.payload;
    },

    decrementRemainingAutoSpins(state) {
      if (state.remainingAutoSpins > 0) {
        state.remainingAutoSpins -= 1;
      }
    },
  },
});

// Export the actions for components or middleware
export const {
  toggleFullscreen,
  closeFullscreen,
  setAutoSpinCount,
  startAutoPlay,
  stopAutoPlay,
  decrementRemainingAutoSpins,
  toggleSimulationMode,
  setSimulationMode,
} = settingsSlice.actions;

// Export the reducer for integration with the Redux store
export default settingsSlice.reducer;
